import type { AppStore } from "@momentum/redux-store";
import { createContext } from "react-router";

export const storeContext = createContext<AppStore>();
